import Vue from 'vue'
import NastCore from 'nast'
import settings from './_config'
import libs from './_libs'
import ui from './_ui'
import components from 'components/Index'
import { createCoolApi } from './_config/coolApiConfig'

Vue.mixin({ components })

// plugins
Vue.use(ui)
NastCore.createApp(settings, libs)

// Настройка апишки от микросервиса
const { coolApi, nastApi } = createCoolApi(settings, libs)
global.$coolApi = coolApi
global.$app.coolApi = nastApi